export enum ExchangeDnCreationEnum {
  AUTOMATICALLY = "automatically",
  MANUALLY = "manually",
}
